export default "__VITE_ASSET__DO0Ur6sf__"